import $ from 'jquery';
import { displayImageManager } from '../../displayImageManager';

export const onClickImageTag = (event) => {
  const sidebarCurrentImagesTagItemId = $(event.currentTarget).data(
    'images-item-id'
  );
  displayImageManager(sidebarCurrentImagesTagItemId);
};
